import Chip from "@mui/material/Chip";
import { makeStyles } from "tss-react/mui";
import { ChipTypes } from "helpers/getDefectChipTypesCc";

const EMIChip = ({
	label = "Chips",
	clickHandler,
	deleteHandler,
	className = null,
	disabled,
	data,
	hideChips = [1, 2, 3], // chipType : 1, 2, 3 comes from the Filter by Dropdown
}) => {
	const useStyles = makeStyles()((theme) => ({
		content: {
			display: "flex",
			flexDirection: "row",
			gap: 5,
			marginBottom: 15,
			flex: "1",
			justifyContent: "start",
			alignItems: "center",
			flexGrow: "1",
			flexWrap: "wrap",
		},
	}));

	const { classes } = useStyles();

	return (
		<div style={{ marginTop: 20 }}>
			<div className={`${classes.content} ${className}`}>
				{data
					?.filter((item) => !hideChips.includes(item.chipType))
					.map((item, index) => (
						<Chip
							key={item.id || index}
							label={
								`${ChipTypes(item.chipType)[0]?.caption} : ${
									item.chipType === 8 ? (item.value ? "Yes" : "No") : item.value
								} ` ?? label
							}
							variant="outlined"
							onClick={clickHandler}
							onDelete={() => deleteHandler?.(item)}
							sx={{
								fontSize: "15px",
								borderColor: "#307ad6",
								color: "#307ad6",
								padding: "20px 5px",
								borderRadius: "60px",
								"& .MuiChip-deleteIcon": {
									fill: "#307ad6",
								},
							}}
							disabled={disabled}
						/>
					))}
			</div>
		</div>
	);
};

export default EMIChip;
